/**
 * Convierte una fecha a formato tipo ISO en hora local (YYYY-MM-DDTHH:mm:ss)
 */
export const toLocalISOString = (date = new Date()) => {
  const pad = n => String(n).padStart(2, '0');

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};

/**
 * Obtiene la fecha de hoy en formato YYYY-MM-DD (hora local)
 */
export const obtenerFechaHoyISO = () => {
  const hoy = new Date();
  const pad = n => String(n).padStart(2, '0');

  return `${hoy.getFullYear()}-${pad(hoy.getMonth() + 1)}-${pad(hoy.getDate())}`;
};

/**
 * Formatea una fecha ISO (YYYY-MM-DD) a formato local legible
 * Ej: "17/03/2026"
 */
export const formatearFechaLocal = (fechaISO) => {
  if (!fechaISO) return '';

  const [year, month, day] = fechaISO.split('-').map(Number);
  const date = new Date(year, month - 1, day);

  return date.toLocaleDateString('es-ES', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
};

/**
 * Convierte una fecha ISO a objeto Date local (sin problemas de zona horaria)
 */
export const isoADateLocal = (fechaISO) => {
  if (!fechaISO) return null;

  const [year, month, day] = fechaISO.split('-').map(Number);
  return new Date(year, month - 1, day);
};

/**
 * Normaliza una fecha ISO completa (con hora) a solo la parte YYYY-MM-DD
 */
export const normalizarFechaISO = (isoString) => {
  if (!isoString) return '';

  if (isoString.length === 10) return isoString;

  return isoString.split('T')[0];
};

/**
 * Combina una fecha YYYY-MM-DD con la hora local actual
 * y devuelve YYYY-MM-DDTHH:mm:ss sin conversiones UTC.
 */
export const combinarFechaConHoraActual = (fechaISO, horaBase = new Date()) => {
  const fechaNormalizada = normalizarFechaISO(fechaISO);

  if (!fechaNormalizada) {
    return toLocalISOString(horaBase);
  }

  const [year, month, day] = fechaNormalizada.split('-').map(Number);
  const fechaLocal = new Date(
    year,
    month - 1,
    day,
    horaBase.getHours(),
    horaBase.getMinutes(),
    horaBase.getSeconds()
  );

  return toLocalISOString(fechaLocal);
};

/**
 * Convierte un valor de input datetime-local a formato local persistible.
 */
export const dateTimeLocalAISO = (dateTimeLocal) => {
  if (!dateTimeLocal) return '';

  const [fecha, hora = '00:00'] = dateTimeLocal.split('T');
  const [year, month, day] = fecha.split('-').map(Number);
  const [hours = 0, minutes = 0, seconds = 0] = hora.split(':').map(Number);

  return toLocalISOString(new Date(year, month - 1, day, hours, minutes, seconds));
};

/**
 * Convierte una fecha persistida local a formato compatible con datetime-local.
 */
export const isoAFechaDateTimeLocal = (isoString) => {
  if (!isoString) return '';

  const [fecha, hora = '00:00:00'] = isoString.split('T');
  const [hours = '00', minutes = '00'] = hora.split(':');

  return `${fecha}T${hours}:${minutes}`;
};

/**
 * Formatea una fecha ISO a formato largo en español
 * Ej: "martes, 17 de marzo de 2026"
 */
export const formatearFechaLarga = (fechaISO) => {
  if (!fechaISO) return '';

  const date = isoADateLocal(fechaISO);

  return date.toLocaleDateString('es-ES', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};